import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import './Footer.scss';

const Footer = () => {
    const [t] = useTranslation();

    return (
        <footer>
            <Link to="/legal-hints" target="_blank"
                  rel="noreferrer">{t('footer.LEGAL_NOTICE')}</Link>
            <Link to="/terms-of-use" target="_blank"
                  rel="noreferrer">{t('footer.TERMS_OF_USE')}</Link>
            <Link to="/data-privacy" target="_blank"
                  rel="noreferrer">{t('footer.PRIVACY_POLICY')}</Link>
            <Link to="/impressum" target="_blank"
                  rel="noreferrer">{t('footer.IMPRINT')}</Link>
        </footer>
    );
};

export default Footer;
